import { isValidPrice } from '@domain-group/javascript-utils'

export type ProviderPriceListItemOptionValueModel = {
  cache_key: number,
  hidden: boolean,
  id: number,
  is_default: boolean,
  is_upgrade: boolean,
  is_downgrade: boolean,
  price: number,
  product_code?: string,
  provider_price_list_id: number,
  provider_price_list_item_option_id: number,
  provider_product_option_value_code?: string,
  sort: number,
  title: string,
}

export type ProviderPriceListItemOptionValueRequestOptions = {}

const state = {
  hidden: false,
  id: null,
  is_default: false,
  price: 0,
  product_code: '',
  provider_price_list_item_option_id: '',
  title: '',
}

export const requiredFields = [
  { key: 'price', validation: isValidPrice },
  { key: 'provider_price_list_item_option_id' },
  { key: 'title' },
]

export default state
